import { CellProps } from 'react-table'
import { UnidadesActionsCell } from './UnidadesActionsCell'
import {
  PlainHeader,
  SelectionCell,
  SelectionHeader,
  sortableColumn,
  StackedCell,
  TableColumn,
} from '../../../../../../components'
import { useQueryRequest } from '../../core/QueryRequestProvider'
import { useListView } from '../../core/ListViewProvider'
import { UnidadeList } from '../../core/_models'
import { TFunction } from '_metronic/i18n/Metronici18n'

export const unidadesColumns = (t: TFunction): ReadonlyArray<TableColumn<UnidadeList>> => [
  {
    Header: (props) => (
      <SelectionHeader
        useListView={useListView}
        tableProps={props}
        ariaLabel='Selecionar todas desta página'
      />
    ),
    id: 'selection',
    cellWidth: '48px',
    Cell: ({ row }: CellProps<UnidadeList>) => (
      <SelectionCell
        useListView={useListView}
        id={row.original.id}
        ariaLabel={`Selecionar ${row.original.nome ?? ''}`}
      />
    ),
  },
  // Código é a linha de apoio do nome; os dois seguem ordenáveis.
  sortableColumn<UnidadeList>({
    id: 'nome',
    useQueryRequest,
    fields: [
      { field: 'nome', label: t('cols.unidade') },
      { field: 'codigo', label: t('cols.codigo') },
    ],
    Cell: ({ row }: CellProps<UnidadeList>) => (
      <StackedCell primary={row.original.nome} secondary={row.original.codigo} />
    ),
  }),
  {
    Header: () => <PlainHeader>{t('cols.tipo')}</PlainHeader>,
    id: 'tipo',
    cellWidth: '200px',
    Cell: ({ row }: CellProps<UnidadeList>) => (
      <StackedCell
        primary={row.original.tipo?.nome}
        {...(row.original.ceae && { secondary: 'Unidade CEAE' })}
      />
    ),
  },
  {
    Header: () => <PlainHeader>CNES</PlainHeader>,
    id: 'cnes',
    cellWidth: '240px',
    hideOnMobile: true,
    Cell: ({ row }: CellProps<UnidadeList>) => (
      <StackedCell tabular primary={row.original.cnes} secondary={row.original.nomeCnes} />
    ),
  },
  {
    Header: () => <PlainHeader>{t('cols.actions')}</PlainHeader>,
    id: 'actions',
    cellWidth: '132px',
    align: 'end',
    Cell: ({ row }: CellProps<UnidadeList>) => <UnidadesActionsCell unidade={row.original} />,
  },
]
